import type { SupportMessageDto } from "@klantpunt/shared";
import { IconFile } from "../../app/icons";
import { initials } from "../../app/ProfileMenu";
import { fmtDateTime, fmtSize } from "./api";

const TYPE_LABEL: Record<SupportMessageDto["type"], string> = {
  customer: "Klant",
  agent: "Antwoord",
  note: "Interne notitie",
  system: "",
};

/**
 * Gesprek bij een bericht. In de inbox staan notities (anders opgemaakt) en systeemregels ertussen;
 * de klant krijgt die nooit (de API stuurt ze niet mee).
 */
export function Thread({
  messages,
  view,
}: {
  messages: SupportMessageDto[];
  /** support: inbox; customer: Mijn berichten */
  view: "support" | "customer";
}) {
  const attUrl = (id: string) => `/api/${view === "support" ? "support" : "help"}/attachments/${id}`;
  return (
    <ol className="sp-thread" aria-label="Gesprek">
      {messages.map((m) =>
        m.type === "system" ? (
          <li key={m.id} className="sp-sys" data-type="system">
            <span>{m.body}</span> <time dateTime={m.createdAt}>{fmtDateTime(m.createdAt)}</time>
          </li>
        ) : (
          <li
            key={m.id}
            className={`sp-msg sp-${m.type}${view === "customer" && m.type === "customer" ? " sp-own" : ""}`}
            data-type={m.type}
          >
            <div className="sp-mhead">
              <span className="avatar sp-mavatar" aria-hidden="true">
                {initials({ name: m.author?.name ?? null, email: m.author?.email ?? "?" })}
              </span>
              <strong>{view === "customer" && m.type === "customer" ? "Jij" : (m.author?.name ?? "Onbekend")}</strong>
              {view === "support" && m.type !== "customer" && <span className="sp-tag">{TYPE_LABEL[m.type]}</span>}
              <time dateTime={m.createdAt} className="muted small">
                {fmtDateTime(m.createdAt)}
              </time>
            </div>
            <div className="prewrap">{m.body}</div>
            {m.attachments.length > 0 && (
              <ul className="sp-atts">
                {m.attachments.map((a) => (
                  <li key={a.id}>
                    <a href={attUrl(a.id)} target="_blank" rel="noreferrer">
                      <IconFile size={16} aria-hidden="true" />
                      {a.filename}
                    </a>{" "}
                    <span className="muted small">{fmtSize(a.sizeBytes)}</span>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ),
      )}
    </ol>
  );
}
